import { render, staticRenderFns } from "./BloqueosHorario.vue?vue&type=template&id=3b773bb4&scoped=true&"
import script from "./BloqueosHorario.vue?vue&type=script&lang=js&"
export * from "./BloqueosHorario.vue?vue&type=script&lang=js&"
import style0 from "./BloqueosHorario.vue?vue&type=style&index=0&id=3b773bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b773bb4",
  null
  
)

export default component.exports